import axios from "@/plugins/axios";

let url = "/api/console/shop/deliveries";

export default {
    getDeliveries(data){
        return axios.get(url, data).then(result => result.data);
    },
    // getDelivery(data){
    //     return axios.get(`${url}/${data._id}`).then(result => result.data);
    // },
    // postDelivery(data){
    //     return axios.post(url, data).then(result => result.data);
    // },
    putDelivery(data){
        return axios.put(`${url}/${data._id}`, data).then(result => result.data);
    },
    // deleteDelivery(data){
    //     return axios.delete(`${url}/${data._id}`).then(result => result.data);
    // }
}
